import { useState, useContext, useEffect } from 'react';
import DebugInfoContext from '../../context/DebugContext';
import SideBarTable from './SideBarTable';


const SideBar = () => {
    const [activeTab, setActiveTab] = useState(1);

    const [tableObject, setTableObject] = useState({});

    const { isDataReady } = useContext(DebugInfoContext)
    const { impInfoData } = useContext(DebugInfoContext)
    const { AgentData } = useContext(DebugInfoContext)

    useEffect(() => {
        if (!isDataReady) {
            setTableObject(null);
        } else {
            if (activeTab === 1) {
                setTableObject({ ...impInfoData?.summary?.attributes });
            } else if (activeTab === 2) {
                setTableObject({ ...AgentData });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDataReady, activeTab])

    const tabs = [
        {
            id: 1,
            title: 'Electric IMP',
            content: (
                <div style={{ display: activeTab === 1 ? 'block' : 'none' }}>
                    <div className=''>
                        {tableObject && isDataReady && <SideBarTable tableObjectData={tableObject} />}
                    </div>
                </div>
            ),
        },
        {
            id: 2,
            title: 'Agent',
            content: (
                <div style={{ display: activeTab === 2 ? 'block' : 'none' }}>
                    <div >
                        {tableObject && isDataReady && <SideBarTable tableObjectData={tableObject} />}
                    </div>
                </div>
            ),
        },
        // Add more tabs as needed
    ];

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
    };

    return (
        <>
            <div className='w-full shadow-xl h-full overflow-y-hidden object-right-top '>
                <div className='flex justify-between'>
                    {tabs.map((tab) => (
                        <div key={tab.id} className={`flex-1 py-2 ${activeTab === tab.id ? 'border-b-2 border-[#38D68B]' : ''} text-center text-sm 2xl:text-base`}>
                            <span onClick={() => handleTabClick(tab.id)} className={`cursor-pointer ${activeTab === tab.id ? 'font-semibold' : ' text-placeholder font-light text-base '} `}>
                                {tab.title}
                            </span>
                        </div>
                    ))}
                </div>
                <hr className=" h-[1px] border-t-0 bg-dividerLines " />
                {tableObject === null && !isDataReady ?
                    (
                        <div className='h-full flex justify-center items-center '>
                            <span className='text-base text-center text-placeholder'>No Data Available</span>
                        </div>
                    ) :
                    (
                        tabs.map((tab) => (
                            <div key={tab.id}>
                                {tab.content}
                            </div>
                        ))
                    )
                }
            </div>
        </>
    );
};

export default SideBar;
